/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsOrgEvents } from "../../funcs/budgetsOrgEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListOrgBudgetEventsRequest$inboundSchema,
};

export const tool$budgetsOrgEvents: ToolDefinition<typeof args> = {
  name: "budgets-org-events",
  description: `List org budget events

Returns recent threshold-alert and block events for the org's budgets. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsOrgEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
